import 'slick-carousel';

$('.js-top-banner').slick({
	arrows: true,
	dots: true,
});

$('.js-reviews-slider').slick({
	arrows: true,
	dots: false,
	infinite: false,
	slidesToShow: 1,
	slidesToScroll: 1,
	mobileFirst: true,
	responsive: [
		{
			breakpoint: 576,
			settings: {
				slidesToShow: 2,
			},
		},
		{
			breakpoint: 768,
			settings: {
				slidesToShow: 3,
			},
		},
	],
});

$('.js-news-slider').slick({
	arrows: true,
	dots: false,
	infinite: false,
	slidesToShow: 2,
	slidesToScroll: 1,
	initialSlide: 1,
	mobileFirst: true,
	responsive: [
		{
			breakpoint: 576,
			settings: {
				slidesToShow: 3,
			},
		},
		{
			breakpoint: 768,
			settings: {
				slidesToShow: 4,
			},
		},
	],
});

$('.js-about-section__show-news').click(function () {
	// Hacky
	setTimeout(function () {
		$('.js-news-slider').slick('setPosition');
	}, 100);
});

$('.js-videos__slider').slick({
	arrows: true,
	dots: false,
	infinite: false,
	slidesToShow: 4,
	slidesToScroll: 1,
});

$('.js-education-gallery__slider').slick({
	arrows: true,
	dots: false,
	infinite: false,
	draggable: false,
	slidesToShow: 2,
	slidesToScroll: 1,
	mobileFirst: true,
	responsive: [
		{
			breakpoint: 768,
			settings: {
				slidesToShow: 3,
			},
		},
	],
});
